import { render, staticRenderFns } from "./fee.component.vue?vue&type=template&id=04fd99a1&scoped=true&"
import script from "./fee.component.vue?vue&type=script&lang=ts&"
export * from "./fee.component.vue?vue&type=script&lang=ts&"
import style0 from "./fee.component.vue?vue&type=style&index=0&id=04fd99a1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd99a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
